import i18n from "i18next"
import Backend from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"
import { Resources as ResourcesType } from "./__generated/i18n-types"

declare module "react-i18next" {
  interface CustomTypeOptions {
    resources: ResourcesType
  }
}

export const namespaces = [
  "calendarEvent",
  "choose-intro-video-type-page",
  "common",
  "customer",
  "errors",
  "hour-report",
  "member-welcome-page",
  "membership",
  "org",
  "org-welcome-page",
  "permission",
  "project",
  "signup",
  "storage-file",
  "supplier",
  "task",
  "todo",
  "translation",
  "treegrid",
  "user-welcome-page",
  "workspace",
]

export const initI18n = () =>
  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: "en",
      defaultNS: "translation",
      ns: namespaces,
      debug: process.env.NODE_ENV === "development",
      backend: {
        loadPath: `/locales/{{lng}}/{{ns}}.json`,
      },
      detection: {
        order: ["localStorage"],
        lookupLocalStorage: "starbrix_language",
        caches: ["localStorage"],
      },
    })
